import React, {useContext, useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {createPlan, getPlanFeatures} from '../plan-list/core/_requests'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../../../auth'
import {AlertContext} from '../../../../../_metronic/layout/components/alert-context'
import {useQueryResponse} from '../plan-list/core/QueryResponseProvider'
import {initialValues} from '../../../../pages/core/_models'
import {Plan} from '../plan-list/core/_models'

//Validation
const PlanDetailsSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  // type: Yup.string().required('Type is required'),
  // planFeaturesName: Yup.string().required('Plan Features is required'),
  // planValidity: Yup.string().required('Plan Validity is required'),
  // amount: Yup.string().required('Amount is required'),
  

})

//Function Starts
const PlanDetails: React.FC = () => {
  const {showAlert} = useContext(AlertContext)
  const {refetch} = useQueryResponse()
  const [data, setData] = useState<Plan>(initialValues)
  const navigate = useNavigate()
  const [formImage, setFormImage] = useState<File | null>(null)
  const {currentUser} = useAuth()
  const type = currentUser?.type
  const [loading, setLoading] = useState(false)
  const [planfeatures, setPlanFeatures] = useState<any>([])

  useEffect(() => {
    getPlanFeatures().then((res: any) => {
      setPlanFeatures(res.data.data)
      console.log('editRoleres=>', planfeatures)
    })
  }, [])

  //formik Starts
  const formik = useFormik<Plan>({
    initialValues: {
      ...initialValues,
    },
    validationSchema: PlanDetailsSchema,
    //Form Submit
    onSubmit: async (values, {resetForm}) => {
      setLoading(true)
      const updatedData = {
        name: values.name,
        type: values.type,
        planValidity: values.planValidity,
        planfeaturesId: values.planfeaturesId,
        amount: values.amount,
      }
      console.log('updatedData', updatedData)
      try {
        const res = await createPlan(updatedData)
        console.log('plannn-Alertres', res?.message)
        resetForm()
        setData(initialValues)
        setFormImage(null)
        navigate('/plan', {replace: true})
        refetch()
        showAlert(res?.message, res?.status)
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    },
    enableReinitialize: true,
  })

  console.log('formik', formik)
  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Add Plan </h3>
        </div>
      </div>

      <div id='kt_account_profile_details'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/** Name */}
            <div className='row mb-6'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Name</label>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Enter Plan '
                    {...formik.getFieldProps('name')}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.name}</div>
                    </div>
                  )}
                </div>
                {/* Type */}
                <div className='col-lg-6 fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Type</label>
                  <select
                    className='form-select form-select-solid form-select-lg'
                    {...formik.getFieldProps('type')}
                  >
                    <option value=''>Select a name..</option>
                    <option value='0'>Free</option>
                    <option value='1'>Premium</option>
                    <option value='2'>Gold</option>
                    <option value='4'>Others</option>
                  </select>
                  {formik.touched.type && formik.errors.type && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.type}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Plan Features */}
            <div className='row mb-6'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Plan Features</label>
                  <select
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Plan Features'
                    {...formik.getFieldProps('planfeaturesId')}
                  >
                    <option value=''>Select a Plan Features</option>
                    {planfeatures.map((item: any, i: any) => {
                      return (
                        <option key={i} value={item.id}>
                          {item.planFeaturesName}
                        </option>
                      )
                    })}
                  </select>
                  {formik.touched.planfeaturesId && formik.errors.planfeaturesId && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.planfeaturesId}</div>
                    </div>
                  )}
                </div>
                {/* Plan Validity */}
                <div className='col-lg-6 fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Plan Validity</label>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Plan Validity '
                    {...formik.getFieldProps('planValidity')}
                  />
                  {formik.touched.planValidity && formik.errors.planValidity && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.planValidity}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Amount */}
            <div className='row mb-6'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <label className='col-form-label required fw-bold fs-6'>Amount</label>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Plan Validity '
                    {...formik.getFieldProps('amount')}
                  />
                  {formik.touched.amount && formik.errors.amount && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.amount}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button type='submit' className='btn btn-primary' disabled={loading}>
              {!loading && 'Save Changes'}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default PlanDetails
